import { Injectable } from '@angular/core';
import { handleError } from '@core/helpers';
import {
  ClinicDetails,
  ClinicSearchResults,
  HoursOfOperation,
} from '@core/models';
import { ClinicService } from '@core/services/clinic.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  getClinicDetails,
  getClinicDetailsFailure,
  getClinicDetailsSuccess,
  getClinics,
  getClinicsFailure,
  getClinicsSuccess,
} from './actions';

@Injectable()
export class ClinicEffects {
  getClinics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getClinics),
      switchMap(({ payload }) =>
        this.clinicService.getClinics(payload).pipe(
          map((clinicSearchResults: ClinicSearchResults) =>
            getClinicsSuccess({ clinicSearchResults }),
          ),
          catchError((error) => handleError(error, getClinicsFailure)),
        ),
      ),
    ),
  );

  getClinicDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getClinicDetails),
      switchMap(({ clinicId }) =>
        this.clinicService.getClinicDetails(clinicId).pipe(
          map((clinicDetails: ClinicDetails) => {
            clinicDetails.hoursOfOperation = sortDaysOfWeek(
              clinicDetails.hoursOfOperation,
            );
            return getClinicDetailsSuccess({ clinicDetails });
          }),
          catchError((error) => handleError(error, getClinicDetailsFailure)),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private clinicService: ClinicService,
  ) {}
}

const sortDaysOfWeek = (days: HoursOfOperation[]) => {
  interface sorterType {
    [key: string]: number;
  }
  const sorter: sorterType = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  return days.sort((a: HoursOfOperation, b: HoursOfOperation) => {
    const day1 = sorter[a.dayOfWeek.toLowerCase()];
    const day2 = sorter[b.dayOfWeek.toLowerCase()];
    return day1 - day2;
  });
};
